import { compose, withHandlers, withProps } from 'recompose';
import { withRouter } from 'react-router';

import AutoPayoutEligibilityStep from './AutoPayoutEligibilityStep';
import withNotifications from '../../../../../common/withNotifications';
import withPermissions from '../../../../../auth/utils/withPermissions';
import { canUserViewDashboard, canUserViewReports } from '../../../../../common/helpers/users';
import { AUTO_PAYOUT_ELIGIBILITY_CREDIT_TO_CASH_RATIO_URL } from '../../../../../common/KnowledgeArticleLink/constants';

export default compose(
  withRouter,
  withNotifications,
  withPermissions,
  withProps(props => ({
    name: 'Credit to cash ratio',
    description: 'Increase the ratio of credit to cash transactions for your barbershop services.',
    knowledgeArticleUrl: AUTO_PAYOUT_ELIGIBILITY_CREDIT_TO_CASH_RATIO_URL,
    eligibilityActionDescription: 'See Total Gross Sales',
    hasPermissionsToViewTgsReport: canUserViewReports(props.permissions) && canUserViewDashboard(props.permissions),
  })),
  withHandlers(({
    onEligibilityActionClicked: props => () => {
      if (!props.hasPermissionsToViewTgsReport) {
        props.addNotification({
          title: 'Error',
          level: 'error',
          message: 'You do not have required permissions.\n'
            + 'Please contact a staff manager to update this permission for you.',
        });

        return;
      }

      props.router.push('/reports/dashboard/v2');
    },
  })),
)(AutoPayoutEligibilityStep);
